export default __webpack_public_path__ + "static/media/logo-darwinex.1e62114c.svg";